import type { ReactNode } from "react";
import { RequireAuth as LibRequireAuth } from "@marekl/adminer/shell";
import type { Role, User } from "./queries";

interface Props {
  children: ReactNode;
  roles?: Role[];
}

/** Redirects to /login if the user is not authenticated, or to /dashboard if a role check fails. */
export function RequireAuth({ children, roles }: Props) {
  return (
    <LibRequireAuth
      fallbackPath="/dashboard"
      check={roles ? (user) => roles.includes((user as User).role) : undefined}
    >
      {children}
    </LibRequireAuth>
  );
}
